const isGIA = (product) => {
  if (!product) return false
  if (!product.categories) return false
  return product.categories.some((category) => {
    return category.name.toLowerCase().indexOf('gia ') !== -1
  })
}

export default isGIA
